<template>
  <div class="deskblock">
    <h3>年度运营状况</h3>
    <Row>
      <Col
        class="baifenbi"
        span="24"
        v-for="(item, index) in items"
        :key="index"
      >
        <div>
          <h3>{{ item.num }}%</h3>
          <span>{{ item.title }} {{ item.now }}/{{ item.all }}</span>
        </div>
        <percent :percent="item.num"></percent>
      </Col>
    </Row>
  </div>
</template>
<script>
import percent from "./percent.vue";
export default {
  components: { percent },
  data() {
    return {
      items: [
        {
          num: 0,
          title: "准时到达率",
          all: 0,
          now: 0,
        },
        {
          num: 70,
          title: "异常率",
          all: 0,
          now: 0,
        },
        {
          num: 0,
          title: "退货率",
          all: 0,
          now: 0,
        },
      ],
      searchItem: {
        endTime: 0,
        startTime: 0,
      },
    };
  },
  methods: {
    getData() {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-omc/orders/indexOperationStatistics",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        console.log(data);
        this.items[0].all = data.totalDispatchCount;
        this.items[0].now = data.zsDispatchCount;
        this.items[0].num = data.szPercent;

        this.items[1].all = data.totalDispatchCount;
        this.items[1].now = data.abnormalEventCount;
        this.items[1].num = data.abnormalPercent;

        this.items[2].all = data.totalOrderCount;
        this.items[2].now = data.backOrderCount;
        this.items[2].num = data.backPercent;
      });
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();

      this.searchItem.startTime = new Date(this.yy, 0, 1).getTime();
      this.searchItem.endTime = new Date(this.yy + 1, 0, 1).getTime() - 1000;
      this.getData();
    },
  },
  mounted() {
    this.defaultTime();
  },
};
</script>
<style lang="">
.wuliuicon i {
  font-size: 36px;
}
.baifenbi {
  margin-top: 30px;
}
.baifenbi > div {
  display: flex;
}
.baifenbi > div > span {
  color: #999;
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/block5.vue